<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
  >
    <defs>
      <clipPath id="clippath">
        <polygon
          fill="none"
          points="48 24.43 48 53.93 71 77 83.25 61.29 77.5 33.29 51 20 48 24.43"
        />
      </clipPath>
    </defs>
    <g clip-path="url(#clippath)"><circle
      fill="#85c441"
      cx="48"
      cy="53.93"
      r="29.5"
    /></g>
    <path
      fill="#4f2b1b"
      d="M81.75,53.93c-.07,13.96-8.9,26.93-22.12,31.7s-28.58,.7-37.7-10.25-10.11-26.89-2.79-38.96c7.27-11.98,21.71-18.4,35.48-15.6,13.75,2.8,24.47,13.99,26.74,27.83,.29,1.74,.39,3.51,.4,5.27,.01,2.89,4.51,2.9,4.5,0-.08-16.01-10.23-30.47-25.26-35.98s-32.39-.69-42.45,11.6-11.66,30.35-3.29,44.16c8.33,13.74,24.66,20.82,40.39,17.7s27.72-15.9,30.1-31.35c.31-2.03,.49-4.08,.5-6.13,.01-2.9-4.49-2.9-4.5,0Z"
    />
    <circle
      fill="#4f2b1b"
      cx="48"
      cy="53.93"
      r="4.5"
    />
    <g>
      <rect
        fill="#4f2b1b"
        x="35"
        y="6"
        width="26"
        height="5"
        rx="2.24"
        ry="2.24"
      />
      <rect
        fill="#4f2b1b"
        x="43.12"
        y="10"
        width="9.75"
        height="6"
      />
    </g>
    <g>
      <rect
        fill="#4f2b1b"
        x="68.63"
        y="16.6"
        width="16"
        height="5"
        rx="2.24"
        ry="2.24"
        transform="translate(31 -45.36) rotate(40.71)"
      />
      <rect
        fill="#4f2b1b"
        x="70.7"
        y="19.52"
        width="6"
        height="6"
        transform="translate(32.52 -42.62) rotate(40.71)"
      />
    </g>
  </svg>
</template>
